import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Film, Loader2, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@videoeditorpro.it");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Accesso effettuato");
      navigate("/admin", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  if (loading) return null;

  return (
    <div className="min-h-screen bg-graphite-950 text-white flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://images.pexels.com/photos/927444/pexels-photo-927444.jpeg?w=1600&q=80"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-graphite-950/80 to-graphite-950" />
      </div>

      <div className="relative w-full max-w-md">
        <Link to="/" data-testid="login-back-home" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white mb-8">
          <ArrowLeft strokeWidth={1.5} className="w-4 h-4" /> Torna al sito
        </Link>
        <div className="flex items-center gap-2 mb-8">
          <Film strokeWidth={1.5} className="w-5 h-5 text-gold" />
          <span className="font-display text-lg">Falco<span className="text-gold"> Poulo</span></span>
        </div>
        <h1 className="font-display text-4xl font-medium tracking-tight mb-2">Area riservata</h1>
        <p className="text-white/60 mb-8 text-sm">Accedi per gestire preventivi e progetti.</p>

        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-4">
          <div>
            <label className="block text-xs uppercase tracking-widest text-white/60 mb-2">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="w-full bg-graphite-900 border border-white/10 rounded-md px-4 py-3 text-white focus:outline-none focus:ring-1 focus:ring-gold focus:border-gold"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-white/60 mb-2">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="w-full bg-graphite-900 border border-white/10 rounded-md px-4 py-3 text-white focus:outline-none focus:ring-1 focus:ring-gold focus:border-gold"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="btn-gold w-full justify-center disabled:opacity-60"
          >
            {busy ? <Loader2 strokeWidth={1.5} className="w-4 h-4 animate-spin" /> : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
